import React, {useEffect, useState} from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import TextInput from 'components/TextInput';
import Select from 'components/Select';
import GridBlock from 'components/GridBlock';
import MeasureUnitService from 'services/MeasureUnitService';
import INPUT_TYPE from 'constants/INPUT_TYPE';
import Loading from "components/Loading";

const style = theme => ({
	root: {
		'&>*': {
			flexGrow: 1,
			flexBasis: 0,
			'&:last-child': {
				flexGrow: 2,
				marginLeft: theme.spacing(2),
			}
		}
	},
})

function Units({
	classes,
	formikProps,
	idPrefix,
	disabled,
	unitDisabled,
	type = INPUT_TYPE.NUMBER_POSITIVE_AMOUNT
}) {
	const quantityId = !!idPrefix ? `${idPrefix}.quantity.value` : `quantity.value`;
	const unitId = !!idPrefix ? `${idPrefix}.quantity.uom` : `quantity.uom`
	const [measureUnits, setMeasureUnits] = useState(null);

	useEffect(() => {
		MeasureUnitService.getRequired().then((resp) => setMeasureUnits(resp));
	}, []);

	if (!measureUnits) {
		return (
			<Loading/>
		)
	}

	return (
		<GridBlock className={classes.root}>
			<TextInput
				label={Tr('quantity')}
				id={quantityId}
				formikProps={formikProps}
				type={type}
				required
				disabled={disabled}
			/>
			<Select
				label={Tr('measure_unit')}
				formikProps={formikProps}
				id={unitId}
				required
				disabled={disabled || unitDisabled}
				items={measureUnits}
			/>
		</GridBlock>
	)
}

Units.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(Units);